import React from 'react';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';
import {
  DatabaseFieldInfoDescription,
  DatabaseFieldInfoMessage as InfoMessageContainer,
  DatabaseFieldInfoTitle,
  DatabaseFieldInfoTitleText,
} from './QuestionCard.styles';

interface Props {
  'data-testid': string;
}

export const DatabaseFieldInfoMessage: React.FC<Props> = (props) => {
  const theme = useTheme();

  return (
    <InfoMessageContainer data-testid={props['data-testid']}>
      <DatabaseFieldInfoTitle>
        <StyledIcon
          className="uil uil-exclamation-triangle"
          size="16px"
          color={theme.newPalette.neutral.N900}
        />
        <DatabaseFieldInfoTitleText>
          Displayed for employees only
        </DatabaseFieldInfoTitleText>
      </DatabaseFieldInfoTitle>
      <DatabaseFieldInfoDescription>
        Employees can search and select from company records. External reporters
        can only enter this information manually.
      </DatabaseFieldInfoDescription>
    </InfoMessageContainer>
  );
};
